import React from "react";
import styled from "styled-components";
import { FaRupeeSign } from "react-icons/fa"; // or use any icon library
import { numberDecimalLimitRegex } from "../selectPaymentMode/components/constant";

const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #ccc;
  padding: 8px;
  border-radius: 8px;
  width: 100%;
`;

const IconWrapper = styled.div`
  margin-right: 8px;
  color: #555;
`;

const StyledInput = styled.input`
  border: none;
  outline: none;
  width: 100%;
  font-size: 16px;
`;

export const regexValidate = (regex, string) => {
  if (regex) {
    return regex?.test(string);
  }
  return true;
};

const RupeeInput = ({ value, onChange, placeholder,regex }) => {
  return (
    <InputWrapper>
      <IconWrapper>
        <FaRupeeSign size={16} />
      </IconWrapper>
      <StyledInput
        type="number"
        value={value}
        onChange={(e) => {
          if (regexValidate(regex, e.target.value)) {
            onChange(e.target.value);
          }
        }}
        placeholder={placeholder}
        regex={numberDecimalLimitRegex(10, 2)}
      />
    </InputWrapper>
  );
};

export default RupeeInput;
